import { __assign } from '../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import { keyframes, css } from '@emotion/react';
import styled from '@emotion/styled';
import { Close, Overlay, Content } from '../../../../_externals/.pnpm/@radix-ui_react-dialog@1.1.1_@types_react@18.3.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@radix-ui/react-dialog/dist/index.js';
import tokens from '@lacedltd/design-tokens';
import { mediaQuery } from '../../../helpers/media.js';
import '../../../helpers/animation.js';
import { generateBorder } from '../../../helpers/tokens.js';

var overlayShow = keyframes({
    "0%": { opacity: 0 },
    "100%": { opacity: 1 },
});
var contentShow = keyframes({
    "0%": { opacity: 0, transform: "translateY(-10px)" },
    "100%": { opacity: 1, transform: "translateY(0)" },
});
var drawerShow = keyframes({
    "0%": { transform: "translateY(100%)" },
    "100%": { transform: "translateY(0)" },
});
var getAlignmentStyles = function (align) {
    switch (align) {
        case "top":
            return "flex-start;";
        case "bottom":
            return "flex-end;";
        case "center":
        default:
            return "center;";
    }
};
var baseOverlayStyle = css({
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    position: "fixed",
    inset: 0,
    animation: "".concat(overlayShow, " 250ms forwards"),
    zIndex: tokens.zIndex.modalBackdrop,
});
var DialogClose = styled(Close)(function (_a) {
    var _b = _a.fullscreen, fullscreen = _b === void 0 ? false : _b;
    return (__assign(__assign({ all: "unset", position: "absolute", cursor: "pointer", top: tokens.spacing[4], right: tokens.spacing[4], width: tokens.spacing[6], height: tokens.spacing[6], display: "inline-flex", justifyContent: "center", alignItems: "center", borderRadius: "100%", transition: "0.2s all" }, (fullscreen && {
        width: tokens.spacing[7],
        height: tokens.spacing[7],
        top: tokens.spacing[7],
        right: tokens.spacing[7],
        svg: { width: tokens.spacing[6], height: tokens.spacing[6] },
    })), { "&:focus-visible": {
            outline: generateBorder("s", "solid", "airJordan.300"),
        }, "&:hover": {
            background: tokens.color.airJordan[100],
        } }));
});
var DialogOverlay = styled(Overlay)(baseOverlayStyle);
var DialogAlignment = styled.div(function (_a) {
    var _b;
    var _c = _a.align, align = _c === void 0 ? "center" : _c, _d = _a.justify, justify = _d === void 0 ? "center" : _d, _e = _a.drawer, drawer = _e === void 0 ? false : _e;
    return (_b = {
            position: "fixed",
            inset: 0,
            display: "flex",
            alignItems: getAlignmentStyles(align),
            justifyContent: justify,
            zIndex: tokens.zIndex.modal
        },
        _b[mediaQuery.m.max] = {
            alignItems: drawer ? "flex-end" : getAlignmentStyles(align),
        },
        _b);
});
var DialogContent = styled(Content, {
    shouldForwardProp: function (prop) {
        return !["scrollContainer", "drawer"].includes(prop);
    },
})(function (_a) {
    var _b;
    var _c = _a.width, width = _c === void 0 ? "auto" : _c, _d = _a.scrollContainer, scrollContainer = _d === void 0 ? false : _d, _e = _a.drawer, drawer = _e === void 0 ? false : _e, _f = _a.fullscreen, fullscreen = _f === void 0 ? false : _f;
    return (__assign(__assign({ position: "absolute", maxHeight: "100vh", animation: "".concat(contentShow, " 250ms forwards"), background: tokens.color.yeezy[0], padding: tokens.spacing[7], margin: tokens.spacing[8], opacity: 0, width: "".concat(width, "px"), overflow: "".concat(scrollContainer ? "auto" : "visible") }, (fullscreen && {
        width: "100%",
        height: "100%",
    })), (_b = {}, _b[mediaQuery.m.max] = {
        animation: "".concat(drawer ? drawerShow : contentShow, " 250ms forwards"),
        borderRadius: "".concat(drawer ? tokens.spacing[3] : 0, " ").concat(drawer ? tokens.spacing[3] : 0, " 0 0"),
        width: "100%",
        opacity: 1,
        margin: 0,
    }, _b)));
});

export { DialogAlignment, DialogClose, DialogContent, DialogOverlay, baseOverlayStyle };
//# sourceMappingURL=Dialog.styles.js.map
